export default "__VITE_ASSET__a8r66suN__"